import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5053bcc5"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { class: "label-cell" }),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("col")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "打刻予定", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "定刻（休憩）", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "給与", -1))

import { computed } from "vue";
import type { PropType } from "vue";
import { Application } from "@/types/order/Application";
import {
  formatFromISOString,
  formatFromUnixTimestamp,
  now,
} from "@/utils/date";
import { formatNumber } from "@/utils/number";


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkInfoTable',
  props: {
  application: {
    type: Object as PropType<Application>,
    required: true
  },
  isNotShowFinishWorkTime: {
    type: Boolean,
    default: false,
  }
},
  setup(__props) {

const props = __props;



const displayActualWorkTime = computed(() => {
  return `${
    props.application.startedWorkAt
      ? formatFromISOString(props.application.startedWorkAt, "HH:mm")
      : "XX:XX"
  }-${props.isNotShowFinishWorkTime ? "記録なし" : formatFromUnixTimestamp(now(), "HH:mm")}`;
});

const displayScheduledWorkTime = computed(() => {
  return `${formatFromISOString(
    props.application.appliedStartWorkAt,
    "HH:mm"
  )}-${formatFromISOString(props.application.appliedFinishWorkAt, "HH:mm")}（${
    props.application.appliedHasRest
      ? `${formatFromISOString(
        props.application.appliedStartRestAt,
          "HH:mm"
        )}-${formatFromISOString(props.application.appliedFinishRestAt, "HH:mm")}`
      : "休憩なし"
  }）`;
})

const displaySalary = computed(() => {
  // 応募データの交通費が null になることはあり得ないが、元になる応募データの取得処理に交通費が無かったため以下対応にて追加した
  // https://gitlab.com/caitech/caisuke-front-v2/-/merge_requests/1157
  // そのため、古いデータが store に残っていた場合、値が表示されなくなってしまう
  // 基本的に order.variousAllowances と同じ値が設定されているはずだが、今後応募単位で交通費が変わる可能性もあるため、ここで吸収しておく
  const variousAllowances =
    props.application.variousAllowances || props.application.order.variousAllowances;
  return `${formatNumber(
    props.application.appliedSalaryPerDay + variousAllowances
  )}円（交通費${formatNumber(variousAllowances)}円込）`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", null, [
    _hoisted_1,
    _createTextVNode(),
    _createElementVNode("tr", null, [
      _hoisted_2,
      _createTextVNode(),
      _createElementVNode("td", null, _toDisplayString(displayActualWorkTime.value), 1)
    ]),
    _createTextVNode(),
    _createElementVNode("tr", null, [
      _hoisted_3,
      _createTextVNode(),
      _createElementVNode("td", null, _toDisplayString(displayScheduledWorkTime.value), 1)
    ]),
    _createTextVNode(),
    _createElementVNode("tr", null, [
      _hoisted_4,
      _createTextVNode(),
      _createElementVNode("td", null, _toDisplayString(displaySalary.value), 1)
    ])
  ]))
}
}

})